<template>
	<div>
		<div style="height: 600px;">
			<el-tabs :tab-position="tabPosition" v-model="editableTabsValue" style="height: 600px;margin-top: 5px;" type="border-card" :closable="!isComplete" @tab-remove="removeTab">
				<el-tab-pane v-for="(list,key) in summaryList.DetailList" :key="key" :name="key+''" :label="'小结'+(key+1)">
					<div style="margin-top: 5px;" id="myform">
						<el-form :model="list" label-width="80px">
							<el-form-item label="总结标题">
								<el-input type="text" :readonly="isComplete" v-model="list.TITLE" style="width: 100%;" placeholder="请输入" maxlength="50 " /></el-col>
							</el-form-item>
							<el-form-item label="现象描述">
								<el-input type="textarea" :readonly="isComplete" v-model="list.DESCRIPTION" placeholder="请输入内容" /></el-col>
							</el-form-item>
						</el-form>
					</div>
					<!--<div style="margin-top: 5px;">
							<el-row>
								<el-col :span="3"><span style="font-size: 18px;">现象描述</span></el-col>
								<el-col :span="21">
									
							</el-row>
						</div>-->
					<div style="height: 190px;">
						<div style="width: 50%;float: left;">
							<el-row>
								<el-col :span="6" style="padding-top: 10px;">
									<span style="font-size: 16px;">&nbsp;对象实例</span>
									<br/><br/>
									<div style="margin-left: 20px;">
										<el-button type="primary" icon="el-icon-plus" @click="addKnowledge" :disabled="isComplete" circle></el-button>
										<br/><br/>
										<el-button type="danger" icon="el-icon-delete" circle @click="delKnowledge" :disabled="isComplete"></el-button>
									</div>
								</el-col>
								<el-col :span="18">
									<el-table :data="list.DeviceList" border style="width: 100%" :row-class-name="tableRowClassName" height="190px">
										<el-table-column :show-overflow-tooltip="true" prop="DEVICENAME" label="设备名称" min-width="50%">
										</el-table-column>
										<el-table-column :show-overflow-tooltip="true" prop="SERIES" label="系列型号" min-width="50%">
										</el-table-column>
										<!--<el-table-column prop="address" label="物理位置">
							</el-table-column>-->
									</el-table>
								</el-col>
							</el-row>
						</div>
						<div style="width: 50%;float: right;">
							<el-row>
								<el-col :span="6" style="padding-top: 10px;padding-left: 5px;">
									<span style="font-size: 16px;">&nbsp;运维对象</span>
									<br/><br/>
									<div style="margin-left: 20px;">
										<el-button type="primary" icon="el-icon-plus" :disabled="isComplete" @click="addBSMV" circle></el-button>
										<br/><br/>
										<el-button type="danger" icon="el-icon-delete" :disabled="isComplete" @click="delBSMV" circle></el-button>
									</div>
								</el-col>
								<el-col :span="18">
									<el-table :data="list.OPobjectList" border style="width: 100%" :row-class-name="tableRowClassName" height="190px">
										<el-table-column :show-overflow-tooltip="true" prop="OPOBJECTNAME" label="运维对象名称" min-width="100%">
										</el-table-column>
									</el-table>
								</el-col>
							</el-row>
						</div>
					</div>
					<div style="width: 100%;margin-top: 15px;">
						<el-row>
							<el-col :span="3">
								<div style="margin-top:0px;">
									<span style="font-size: 16px;">&nbsp;总结内容</span>
									<br/><br/>
									<el-button type="primary" id="myBtn" size="small" icon="el-icon-download" :disabled="isComplete" @click="knowledgeDialogVisible = true">知识条目</el-button>
									<br/><br/>
									<el-button type="success" id="myBtn" size="small" icon="el-icon-download" :disabled="isComplete" @click="workDialogVisible = true">工作记录</el-button>
									<br/><br/>
									<uploadFiles :ref="'uploadFiles'+key" @newList="getFile" :filesArray="FileLists[key].FileList"></uploadFiles>
								</div>
							</el-col>
							<el-col :span="21">
								<div style="margin-right:0px ;">
									<WangEdit :initHeight="initHeight" :ref="'wangEdit'+key" @contentChanged="getEditChanged" :initContent="initRichEditContent"></WangEdit>
									<el-checkbox v-model="hideWindow" :disabled="isComplete">当前窗口</el-checkbox>
									<el-button size="small" :disabled="isComplete" @click="captureStart" type="primary">截图</el-button>
									<el-checkbox v-model="list.SAVEKMS" style="float: right;margin-top: 5px;" :disabled="isComplete">保存至知识库</el-checkbox>
									<!--<uploadFiles @newList="getFile" :filesArray="FileLists[key].FileList"></uploadFiles>-->
									<!--<el-button size="small" type="primary">添加文件</el-button>-->
								</div>
							</el-col>
						</el-row>
					</div>
					<div style="margin-top: 5px;width: 100%;text-align: center;">
						<el-button :disabled="isComplete" type="text" @click="addTab(editableTabsValue)">
							+添加总结
						</el-button>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<el-dialog title="知识库" :visible.sync="knowledgeDialogVisible" :before-close="knowledgeHandleClose" width="800px" center append-to-body>
			<div style="height: 430px;">
				<el-row>
					<KnowledgeSearchExpand ref="searchDetail"></KnowledgeSearchExpand>
				</el-row>
				<el-row class="is-justify-center el-row--flex">
					<el-col :span="18">
						<div style="box-sizing:border-box;width:100%;">
							<el-input placeholder="请输入综合搜索内容" v-model="txtSearch" @keyup.13.native="btnDoSearch">
							</el-input>
						</div>
					</el-col>
					<el-col :span="6">
						<el-button style="margin-left:20px" type="primary" icon="el-icon-search" title="搜索" @click="SearchKnowledge">搜索</el-button>
					</el-col>
				</el-row>
				<el-row :span="24" class="tablePanel">
					<el-table :data="tableData" ref="knowledgeTable" border style="width: 100%;" highlight-current-row class="tableKeyword" @current-change="handleCurrentChange" @selection-change="changeFun" @row-dblclick="showKnowledgeDetail" height="260px">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column prop="INSTANCE" label="ID编号" width="95" sortable>
						</el-table-column>
						<el-table-column prop="TITLE" label="标题" width="360" :show-overflow-tooltip="true" sortable>
						</el-table-column>
						<el-table-column prop="TagNames" label="关键词" width="120" :show-overflow-tooltip="true" sortable>
						</el-table-column>
						<el-table-column prop="KNOWLEDGETYPENAME" label="知识类型" width="120" :show-overflow-tooltip="true" sortable>
						</el-table-column>
						<el-table-column prop="KNOWLEDGECLASSNAME" label="知识分类" width="120" :show-overflow-tooltip="true" sortable>
						</el-table-column>
						<el-table-column prop="CREATETIME" label="创建时间" width="170" :show-overflow-tooltip="true" sortable :formatter="timeFormatter">
						</el-table-column>
						<el-table-column prop="AUTHORNAME" label="作者" width="120" sortable>
						</el-table-column>
						<el-table-column prop="SOURCE" label="来源" width="100" :show-overflow-tooltip="true" sortable :formatter="sourceFormatter">
						</el-table-column>
					</el-table>
				</el-row>
				<el-row :span="24" class="pagePanel">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange" :current-page="currentPage" :page-sizes="pageSizesArr" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
					</el-pagination>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="knowledgeDialogVisible = false">取 消</el-button>
   				<el-button type="primary" @click="sureKnowledgeDia">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="工作记录" :visible.sync="workDialogVisible" :before-close="workHandleClose" width="800px" center append-to-body>
			<el-form :model="workForm" class="demo-form-inline">
				<el-form-item label="名称/编号">
					<el-col :span="17">
						<el-input v-model="workForm.input" placeholder="请输入名称/编号"></el-input>
					</el-col>
					<el-col :span="1">
						&nbsp;
					</el-col>
					<el-col :span="2">
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-col>
				</el-form-item>
			</el-form>
			<el-scrollbar style="height: 100%;">
				<div style="height: 400px;">
					<el-row v-for="(c,index) in works" :key="index" style="margin-top: 3px;">
						<el-col :span="24">
							<el-card :body-style="{ padding: '0px'}" shadow="hover">
								<div style="padding: 14px;">
									<div>
										<span v-html="delHtmlTag(c.INFO)"></span>
										<div class="bottom clearfix">
											<table style="width:100%;">
												<tr>
													<td><time class="time">
														时间：
														{{c.CREATETIME|timeFormater}}
														&nbsp;&nbsp;|&nbsp;&nbsp;
														创建人：
														{{c.CREATEUSERNAME}}
													</time></td>
													<td style="width:90px;line-height:30px">
														<el-button type="text" class="button" style="color:#6aca5d" @click="sureWork(c.INFO)">选中</el-button>
													</td>
												</tr>
											</table>
										</div>
									</div>
								</div>
							</el-card>
						</el-col>
					</el-row>
				</div>
			</el-scrollbar>
			<span slot="footer" class="dialog-footer">
				<!--<el-button @click="workDialogVisible = false">取 消</el-button>-->
   				<el-button type="primary" @click="workDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
		<KnowledgeView ref="refknowledgeDetail" :knowledgeData="knowledgeDetail" :showComment='false'></KnowledgeView>
		<commonSelectComponent ref="KnowledgeSel" v-show="display" :myOption="optionSelKnowledgeObj" :myData="dataSelKnowledgeObj" @getValue="SelKnowledgeObjGetValue" @setValue="SelKnowledgeObjSetValue">
		</commonSelectComponent>
		<commonOftenSelect ref="BSMVSel" v-show="display" :myOption="optionSelObjBSMV" :myData="dataSelObjBSMV" @getValue="SelObjBSMVGetValue" @setValue="SelObjBSMVSetValue" @setOftenUseValue="setOftenBSMV">
		</commonOftenSelect>
	</div>
</template>

<script>
	import { listToTree } from '@/api/modules/basicData/commonData'
	import {
		GetAllObjTypeBSMV,
		GetAllGeneralSelTreeEx,
		GetCommonAndUsedObjTypeBSMV,
		GetKnowledgeByParam
	} from '@/api/modules/basicData/knowledge'
	import {
		getTaskSummaryByUserId,
		getAllTaskSummaryByTaskId,
		GetAllRecordsByUserID,
		UploadFiles,
		GetFileInfoByTaskId
	} from "@/api/modules/basicData/task.js";
	import { Linq, DateFormat, TimeFormat } from '@/util/common'
	import { getToken } from '@/util/auth'
	import WangEdit from '@/views/knowledgeBase/WangEdit.vue'
	import commonSelectComponent from '@/components/basicData/commonSelectComponent'
	import commonOftenSelect from '@/components/basicData/commonOftenSelectComponent.vue'
	import KnowledgeSearchExpand from '@/views/knowledgeBase/KnowledgeSearchExpand'
	import KnowledgeView from '@/views/knowledgeBase/KnowledgeView'
	import cap from '@/capturn/capturnwrapper.js'
	import uploadFiles from '@/components/basicData/uploadFiles.vue'
	export default {
		name: 'sunmmaryTask',
		components: {
			WangEdit,
			commonSelectComponent,
			commonOftenSelect,
			KnowledgeSearchExpand,
			KnowledgeView,
			uploadFiles
		},
		data() {
			return {
				workForm: {
					input: ''
				},
				isComplete: false,
				knowledgeDialogVisible: false,
				workDialogVisible: false,
				hideWindow: false,
				editorContent: this.initContent,
				works: [],
				currentUser: {}, //当前登录人员
				txtSearch: "",
				initRichEditContent: '',
				tabPosition: 'right',
				pageSizesArr: [2, 5, 10, 20, 30, 50, 100, 300],
				pageSize: 10,
				currentPage: 1,
				totalCount: 0,
				tableData: [],
				knowledgeSelData: [],
				editableTabsValue: '0',
				currentRow: null,
				searchIconState: "el-icon-arrow-down",
				showDialog: false,
				editDataObj: null,
				knowledgeDetail: {
					TITLE: ""
				},
				editor: null,
				initHeight: '150px',
				display: false,
				dataSelKnowledgeObj: {
					idArray: [],
					imageType: [],
					checkField: {
						Id: "Id",
						Pid: "Pid",
						Key: "AggrID",
						Type: "Type",
						TypeValue: [20, 31, 21, 22, 23, 41, 43, 45, 47, 49, 24, 25, 29, 12, 14, 16, 33, 35, 37, 39],
						ValidField: ["Name", "Ips", "PY", "FullPY"],
						ShowField: 'Name',
						ShowFieldName: "对象实例",
						FiledList: ["Ips"]
					}
				},
				optionSelKnowledgeObj: {
					commomShowPlaceholder: '',
					commonDialogTitle: '选择对象实例',
					commonCheckedDescription: '对象实例',
					isRadio: false,
					setWidth: "100%",
					searchContainsSubsets: true, //搜索后是否包含子级  
					isStrictly: true //父子节点不关联               
				},
				dataSelObjBSMV: {
					idArray: [],
					imageType: [{
						type: 1,
						imgPath: require('@/assets/img/BSMV/类型.png')
					}, {
						type: 2,
						imgPath: require('@/assets/img/BSMV/类型.png')
					}, {
						type: 3,
						imgPath: require('@/assets/img/BSMV/类型.png')
					}, {
						type: 4,
						imgPath: require('@/assets/img/BSMV/类型.png')
					}, {
						type: 5,
						imgPath: require('@/assets/img/BSMV/类型.png')
					}, {
						type: 6,
						imgPath: require('@/assets/img/BSMV/厂商.png')
					}, {
						type: 7,
						imgPath: require('@/assets/img/BSMV/系列.png')
					}, {
						type: 8,
						imgPath: require('@/assets/img/BSMV/型号.png')
					}, {
						type: 9,
						imgPath: require('@/assets/img/BSMV/版本号.png')
					}, ],
					checkField: {
						Id: "Id",
						Pid: "Pid",
						Key: "AggrID", //该字段前端构建，特殊处理
						Type: "Type",
						TypeValue: [1, 2, 3, 4, 5, 6, 7, 8, 9],
						ValidField: ["Name", "PY", "FullPY"],
						ShowField: 'Name',
						ShowFieldName: "产品对象"

					}
				},
				optionSelObjBSMV: {
					commomShowPlaceholder: '',
					commonDialogTitle: '选择产品对象',
					commonCheckedDescription: '产品对象',
					isRadio: false,
					setWidth: "100%",
					searchContainsSubsets: true, //搜索后是否包含子级  
					isStrictly: true //父子节点不关联        
				},
				detailList: [{
					index: '1'
				}],
				myTaskCode: '',
				myTaskName: '',
				myTaskDescreption: '',
				myTaskId: '',
				myUserId: '',
				myTaskState: '',
				summaryList: {
					ID: '',
					TASKID: '',
					CREATEUSERID: '',
					CREATEUSERNAME: '',
					CREATEDEPTID: '',
					CREATEDEPTNAME: '',
					CREATETIME: '',
					ISCOMPLETED: false,
					DetailList: [{
						ID: '',
						SUMMARYID: '',
						TITLE: '',
						CONTENT: '',
						DESCRIPTION: '',
						SAVEKMS: false,
						DeviceList: [],
						OPobjectList: [],
					}]
				},
				FileLists: [{
					FileList: []
				}],
				newFileLists: [{
					FileList: []
				}],
			};
		},
		props: {
			//设置项
			myRowData: {
				type: Object,
				default: function() {
					return {
						userId: '',
						taskId: '',
						taskState: 1,
						Complete: false,
						taskName: "",
						taskDescreption: ""
					}
				}
			},
			isOpen: {
				type: Boolean,
				default: false
			},
		},
		mounted() {
			this.SearchKnowledge();
			//this.currentUser = getToken();
		},
		watch: {
			'myRowData': {
				handler(val, oldVal) {
					this.myTaskName = val.taskName
					this.myTaskDescreption = val.taskDescreption
					this.myTaskId = val.taskId
					this.myUserId = val.userId
					this.myTaskState = val.taskState
					this.isComplete = val.Complete
					this.getTaskDetail()
				},
				deep: true //深度监听
			},
			pageSize() {
				this.SearchKnowledge();
			},
			currentPage() {
				this.SearchKnowledge();
			},
			editableTabsValue: function(val, oldVal) {
				let key = 'wangEdit' + parseInt(val)
				if(this.summaryList.DetailList[parseInt(val)].CONTENT != '') {
					this.$refs[key][0].setHtml(this.summaryList.DetailList[parseInt(val)].CONTENT)
				}
			}
		},
		created() {
			cap.Init(this);
			this.toSetRowData()
		},
		methods: {
			getTaskDetail() {
				if(this.myTaskState == 1 || this.myTaskState == 2) { //执行中
					getTaskSummaryByUserId(this.myTaskId, this.myUserId).then(res => {
						if(res != null && res.DetailList.length > 0) {
							this.editableTabsValue = '0'
							this.FileLists = []
							this.newFileLists = []
							this.summaryList.ID = res.ID
							this.summaryList.DetailList = res.DetailList
							let key = ''
							let arr = {
								FileList: []
							}
							let hisArr = {
								FileList: []
							}
							key = 'wangEdit' + 0
							this.$refs[key][0].setHtml('')
							this.$refs[key][0].setHtml(this.summaryList.DetailList[0].CONTENT)
							for(var i = 0; i < this.summaryList.DetailList.length; i++) {
								if(this.summaryList.DetailList[i].DESCRIPTION != null && this.summaryList.DetailList[i].DESCRIPTION != "") {
									let dd = this.summaryList.DetailList[i].DESCRIPTION.replace(/<\/?.+?>/g, "");
									this.summaryList.DetailList[i].DESCRIPTION = dd.replace(/ /g, ""); //dds为得到后的内容
								}
								this.FileLists.push(hisArr)
								this.newFileLists.push(arr)
								this.getHistoryFiles(i, this.summaryList.DetailList[i].ID)
							}
						} else {
							var _this = this
							this.summaryList = {
								ID: '',
								TASKID: '',
								CREATEUSERID: '',
								CREATEUSERNAME: '',
								CREATEDEPTID: '',
								CREATEDEPTNAME: '',
								CREATETIME: '',
								ISCOMPLETED: false,
								DetailList: [{
									ID: '',
									SUMMARYID: '',
									TITLE: _this.myTaskName,
									CONTENT: '',
									DESCRIPTION: _this.myTaskDescreption,
									SAVEKMS: false,
									DeviceList: [],
									OPobjectList: [],
								}]
							}
							this.FileLists = [{
								FileList: []
							}]
							this.newFileLists = [{
								FileList: []
							}]
							let upKey = 'uploadFiles' + 0
							let key = 'wangEdit' + 0
							this.$refs[key][0].setHtml("")
							this.$refs[upKey][0].reset()
							this.editableTabsValue = '0'
						}
					}).catch(err => {
						console.log("getTaskSummaryByUserId err");
					});
				}
			},
			toSetRowData() {
				this.myTaskId = this.myRowData.taskId
				this.myUserId = this.myRowData.userId
				this.myTaskState = this.myRowData.taskState
				this.isComplete = this.myRowData.Complete
				this.myTaskName = this.myRowData.taskName
				this.myTaskDescreption = this.myRowData.taskDescreption
				this.getTaskDetail()
				this.getWorkRecord('')
			},
			getHistoryFiles(index, ID) {
				GetFileInfoByTaskId(ID, '11').then(res => {
					this.FileLists[index].FileList = res

					//console.log("文件", res)
				}).catch(err => {
					console.log("GetFileInfoByTaskId error");
				})
			},
			getFile(files, cb) {
				this.newFileLists[parseInt(this.editableTabsValue)].FileList = files
				//console.log(this.newFileLists)
				cb("true")
			},
			onSubmit() {
				this.getWorkRecord(this.workForm.input)
			},
			getWorkRecord(input) {
				this.currentUser = getToken()
				GetAllRecordsByUserID(this.currentUser.userId, input).then(res => {
					this.works = res
					console.log("记录", res)
				}).catch(err => {
					console.log("GetKnowledgeByParam error");
				});
			},
			captureStart() { // 截图开始
				cap.StartCapture(!this.hideWindow, this);
			},
			exceedUpload(file, fileList) {
				this.$message.warning('最多上传五个文件')
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			showKnowledgeDetail(row) { //显示知识详情
				this.currentRow = row;
				this.knowledgeDetail = this.currentRow;
				setTimeout(() => {
					this.$refs.refknowledgeDetail.dialogFormVisible = true;
				}, 100);
			},
			handleSizeChange(val) {
				this.pageSize = val;
			},
			handleCurrentPageChange(val) {
				this.currentPage = val;
			},
			handleCurrentChange(val) {
				this.currentRow = val;
			},
			sourceFormatter(row, column) {
				if(row.SOURCE == "0") {
					return "主动添加";
				}
				return "";
			},
			timeFormatter(row, column) {
				return TimeFormat(row.CREATETIME);
			},
			timeFormat(time) {
				return TimeFormat(time);
			},
			idSortmethod(obj1, obj2) {
				var val1 = Number(obj1.INSTANCE);
				var val2 = Number(obj2.INSTANCE);
				return val1 - val2;
			},
			//获取选中的知识
			changeFun(val) {
				this.knowledgeSelData = val;
			},
			getEditChanged(html, text) { //富文本编辑器改变时执行
				this.summaryList.DetailList[parseInt(this.editableTabsValue)].CONTENT = html
			},
			//知识确定
			sureKnowledgeDia() {
				let key = 'wangEdit' + parseInt(this.editableTabsValue)
				//先获取再添加
				let body = this.$refs[key][0].editorContent
				//console.log(body)
				this.knowledgeSelData.forEach((c) => {
					body += c.BODYSTR + "<br/>"
				})
				this.$refs[key][0].setHtml(body)
				this.$refs[key][0].editor.change && this.$refs[key][0].editor.change()
				this.resetKnowledge()
				this.knowledgeDialogVisible = false
			},
			//清空选择知识弹窗
			knowledgeHandleClose(done) {
				this.resetKnowledge()
				done();
			},
			resetKnowledge() {
				this.$refs.searchDetail.$refs.cs1.deleteBtnClick()
				this.$refs.searchDetail.$refs.cs2.deleteBtnClick()
				this.$refs.searchDetail.$refs.cs3.deleteBtnClick()
				this.$refs.searchDetail.$refs.cs4.deleteBtnClick()
				this.$refs.knowledgeTable.clearSelection();
				this.txtSearch = ""
			},
			//知识库搜索
			SearchKnowledge() {
				var para = null;
				let hideOrShowAdvanceSearch = this.searchIconState != "el-icon-arrow-down";
				if(hideOrShowAdvanceSearch) {
					para = {
						PageIndex: this.currentPage,
						PageSize: this.pageSize,
						SearchTxt: this.txtSearch,
						Para: this.$refs.searchDetail.searchPara,
					};
				} else {
					para = {
						PageIndex: this.currentPage,
						PageSize: this.pageSize,
						SearchTxt: this.txtSearch,
						Para: {
							SortStyle: 1
						},
					};
				}
				GetKnowledgeByParam(para).then(res => {
					this.tableData = res.Items;
					this.totalCount = res.TotalItems;
				}).catch(err => {
					console.log("GetKnowledgeByParam error");
				});
			},
			workHandleClose(done) {
				done();
			},
			sureWork(info) {
				let key = 'wangEdit' + parseInt(this.editableTabsValue)
				//先获取再添加
				let body = this.summaryList.DetailList[parseInt(this.editableTabsValue)].CONTENT
				//let body = this.$refs[key][0].editorContent
				body += info + "<br/>"
				this.$refs[key][0].setHtml(body)
				this.$refs[key][0].editor.change && this.$refs[key][0].editor.change()
				this.workDialogVisible = false
			},
			addTab(targetName) {
				this.summaryList.DetailList.push({
					ID: '',
					SUMMARYID: '',
					TITLE: this.myTaskName,
					CONTENT: '',
					DESCRIPTION: this.myTaskDescreption,
					SAVEKMS: '',
					DeviceList: [],
					OPobjectList: [],
				});
				this.FileLists.push({
					FileList: []
				})
				this.newFileLists.push({
					FileList: []
				})
				this.editableTabsValue = (this.summaryList.DetailList.length - 1) + '';
			},
			removeTab(targetName) {
				if(this.summaryList.DetailList.length > 1) {
					let tabs = this.summaryList.DetailList;
					let hisFiles = this.FileLists
					let newFiles = this.newFileLists
					let activeName = parseInt(this.editableTabsValue);
					this.$confirm('删除将无法恢复,是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						for(var i = 0; i < tabs.length; i++) {
							if(i == parseInt(targetName)) {
								hisFiles.splice(i, 1)
								newFiles.splice(i, 1)
								tabs.splice(i, 1)
							}
						}
						if(parseInt(targetName) <= activeName) {
							activeName = activeName - 1
						}
						this.editableTabsValue = activeName + ''
						this.summaryList.DetailList = tabs
						this.FileLists = hisFiles
						this.newFileLists = newFiles
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				}
			},
			SelKnowledgeObjSetValue(value, callback) {
				GetAllGeneralSelTreeEx().then(res => {
					for(let i = 0; i < res.length; i++) {
						res[i].AggrID = res[i].SocialId + "_" + this.GetObjType(res[i].Type);
					}
					callback(res);
				}).catch(err => {
					console.log("SelKnowledgeObjSetValue err");
				});
			},
			GetObjType(type) {
				if(Linq.from([20, 31, 21, 22, 23]).firstOrDefault(s => s == type) != null)
					return 0;
				if(Linq.from([24, 25, 29, 12, 14]).firstOrDefault(s => s == type) != null)
					return 1;
				if(Linq.from([16, 33, 35, 37, 39]).firstOrDefault(s => s == type) != null)
					return 3;
				if(Linq.from([41, 43, 45, 47, 49]).firstOrDefault(s => s == type) != null)
					return 4;
				return -1; //error
			},
			SelKnowledgeObjGetValue(value, callback) {
				let arr = []
				let obj = {}
				value.forEach((c) => {
					obj.TYPE = c.Type
					obj.DEVICEID = c.SocialId
					obj.DEVICENAME = c.Name
					obj.DEVICETYPE = this.GetObjType(c.Type)
					obj.SERIES = c.Serial
					obj.LOCATION = c.AreaName
					arr.push(obj)
				})
				this.summaryList.DetailList[parseInt(this.editableTabsValue)].DeviceList = arr;
			},
			//选择运维对象产品编码
			SelObjBSMVSetValue(value, callback) {
				GetAllObjTypeBSMV().then(res => {
					for(let i = 0; i < res.length; i++) {
						res[i].AggrID = res[i].SocialId + "_" + "12345";
					}
					callback(res);
				}).catch(err => {
					console.log("GetAllObjTypeBSMV err");
				});
			},
			SelObjBSMVGetValue(value, callback) {
				if(value != undefined && value != null) {
					let arr = []
					let obj = {}
					value.forEach((c) => {
						obj.OPOBJECTID = c.SocialId
						obj.OPOBJECTNAME = c.Name
						arr.push(obj)
					})
					this.summaryList.DetailList[parseInt(this.editableTabsValue)].OPobjectList = arr;
				} else {}
			},
			setOftenBSMV(value, callback) {
				GetCommonAndUsedObjTypeBSMV().then(res => {
					for(let i = 0; i < res.length; i++) {
						res[i].AggrID = res[i].SocialId + "_" + "12345";
					}
					callback(res);
				}).catch(err => {
					console.log("GetCommonAndUsedObjTypeBSMV err");
				});
			}, //KnowledgeSel  BSMVSel
			addKnowledge() {
				this.$refs.KnowledgeSel.addBtnClick()
			},
			delKnowledge() {
				this.$refs.KnowledgeSel.deleteBtnClick()
			},
			addBSMV() {
				this.$refs.BSMVSel.addBtnClick()
			},
			delBSMV() {
				this.$refs.BSMVSel.deleteBtnClick()
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if(rowIndex === 1) {
					return 'warning-row';
				} else if(rowIndex === 3) {
					return 'success-row';
				}
				return '';
			},
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},
			handleInputConfirm() {
				let inputValue = "小结33";
				if(inputValue) {
					this.dynamicTags.push({
						name: "小结33",
						type: "danger"
					});
				}
			},
			tagClick(key) {
				for(var i = 0; i < this.dynamicTags.length; i++) {
					if(i == key) {
						this.dynamicTags[i].tagHit = true
					} else {
						this.dynamicTags[i].tagHit = false
					}
				}
			}
		},
		computed: {}
	}
</script>

<style scoped>
	#myform .el-form-item__label {
		font-size: 16px;
	}
	
	#myform .el-form-item {
		margin-bottom: 5px;
	}
	
	.el-card >>> .is-hover-shadow:hover {
		/*-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);*/
		box-shadow: 0 2px 12px 0 #1000ff8a;
		font-size: 16px;
	}
	
	.el-table .warning-row {
		background: #f0f9eb;
	}
	
	.el-table .success-row {
		background: #f0f9eb;
	}
	
	#myBtn {
		padding: 9px 1px;
	}
	
	.toolbar {
		border: 1px solid #ccc;
	}
	
	.el-tag+.el-tag {
		margin-left: 10px;
	}
	
	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}
	
	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}
	
	.time {
		font-size: 13px;
		color: #999;
	}
	
	.bottom {
		margin-top: 13px;
		line-height: 12px;
	}
	
	.button {
		padding: 0;
		float: right;
	}
	
	.el-dialog--center .el-dialog__body {
		text-align: initial;
		padding: 5px 25px 5px;
	}
</style>